module.exports = __webpack_public_path__ + "static/media/ml.1550b6ff.png";